var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimize1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_957_136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.50363 0.0723691C0.799809 0.259778 0.250078 0.822003 0.0626695 1.53416C0.00852933 1.73822 0.000200066 2.6128 0.000200066 8.00183C0.000200066 14.8568 -0.0164585 14.4528 0.254243 14.9609C0.51245 15.4399 1.07467 15.8522 1.62024 15.9563C1.92426 16.0146 14.06 16.0146 14.3723 15.9563C15.1345 15.8147 15.805 15.1442 15.9507 14.3779C16.009 14.0697 16.009 1.93396 15.9507 1.62578C15.8091 0.888637 15.2136 0.263942 14.4723 0.0682044C14.11 -0.0234174 1.85346 -0.0234174 1.50363 0.0723691ZM14.2599 1.39672C14.3349 1.43004 14.4515 1.52583 14.5181 1.61328L14.6389 1.76738V8.00599C14.6389 14.2404 14.6389 14.2446 14.5514 14.3571C14.5056 14.4195 14.414 14.5111 14.3515 14.557C14.2391 14.6444 14.2349 14.6444 8.00046 14.6444H1.76184L1.60775 14.5236C1.31206 14.3029 1.33288 14.7694 1.33288 8.00599C1.33288 3.77056 1.34538 1.85067 1.37869 1.76738C1.437 1.61328 1.57443 1.46336 1.72852 1.39672C1.92009 1.31343 14.0558 1.31343 14.2599 1.39672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72694 11.3918C3.4479 11.5126 3.28965 11.8333 3.34795 12.1456C3.38544 12.3414 3.59367 12.5704 3.78108 12.6246C3.88519 12.6579 5.25119 12.6662 8.0873 12.6579C12.2061 12.6454 12.2394 12.6454 12.3519 12.5579C12.5726 12.3955 12.6392 12.2622 12.6392 11.9999C12.6392 11.7375 12.5726 11.6042 12.3519 11.4418C12.2394 11.3544 12.2061 11.3544 8.04566 11.346C4.62233 11.3377 3.82689 11.346 3.72694 11.3918Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_957_136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize1);
export default __webpack_public_path__ + "static/media/minimize 1.33dacd9b6668ed238642cd327fa20337.svg";
export { ForwardRef as ReactComponent };